import { render, staticRenderFns } from "./StartDialog.vue?vue&type=template&id=2ab8ad18&"
import script from "./StartDialog.vue?vue&type=script&lang=js&"
export * from "./StartDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports